query RunBalanceReconciliation(
  $legalEntity: ReconciliationLegalEntity!
  $fundCategories: [FundCategory!]
  $dateFrom: ISO8601Date
  $dateTo: ISO8601Date
  $exceptionThresholdMinorUnits: Int
) {
  balanceReconciliation(
    legalEntity: $legalEntity
    fundCategories: $fundCategories
    dateFrom: $dateFrom
    dateTo: $dateTo
    exceptionThresholdMinorUnits: $exceptionThresholdMinorUnits
  ) {
    runAt
    parameters {
      legalEntity
      fundCategories
      dateFrom
      dateTo
      exceptionThresholdMinorUnits
    }
    summary {
      currency
      salesforceTotal {
        minorUnit
        currency
      }
      sageTotal {
        minorUnit
        currency
      }
      difference {
        minorUnit
        currency
      }
      lineCount
      exceptionCount
      withinToleranceCount
      unmappedCount
    }
    lines {
      id
      fundAccountId
      fundId
      sageId
      sageGiftAccountId
      fundAccountName
      sageName
      legalEntity
      currency
      fundAccountBalance {
        minorUnit
        currency
      }
      sageBalance {
        minorUnit
        currency
      }
      fundRecordType
      fundCategory
      fundOpenedDate
      isException
      totalDiscrepancy {
        minorUnit
        currency
      }
    }
    unmapped {
      id
      side
      fundAccountId
      fundId
      fundAccountName
      fundRecordType
      fundCategory
      sageGiftAccountId
      sageId
      sageName
      sageClass
      legalEntity
      currency
      balance {
        minorUnit
        currency
      }
    }
  }
}
